module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/OOuRJW/images/e9781439638378_cover.jpg?1684229397178",
      "alt": "This image is the cover for the book Stephen F. Austin State University Jacks, Images of Sports"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Stephen F. Austin State University Jacks, Images of Sports\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Stephen F. Austin State University opened its doors in 1923, and its administrators instituted intercollegiate athletics almost immediately. Over the next eight decades, the Lumberjacks and Ladyjacks�team names derived from the area�s predominant forest products industries�participated successfully in the Lone Star, Gulf Star, and Southland Conferences. Such outstanding Lumberjacks as James Silas, Mark Moseley, and Jeremiah Trotter have even gone on to successful careers in the NBA and NFL. This book offers readers a retrospective look at the success of SFA�s athletic programs, as well as the players, coaches, and fans that led them to victory.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Hardy Meredith, Archie P. McDonald\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Authors Hardy Meredith and Archie P. McDonald are SFA employees and veteran observers of the school�s athletic programs. Meredith has served as SFA�s official photographer for 16 years and staff photographer for the Nacogdoches Daily Sentinel for 13 years. McDonald, a member of the school�s department of history, has been a member of the University Intercollegiate Athletic Council for nearly three decades.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0